import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// Import Vue3-Toastify globally
import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// Import main.css
import "./assets/main.css";

// Create the app instance
const app = createApp(App);

// Use plugins
app.use(store);
app.use(router);

// Configure Vue3-Toastify with colors from main.css
app.use(Vue3Toastify, {
  autoClose: 5000000,
  position: toast.POSITION.BOTTOM_CENTER,
  hideProgressBar: true,
  theme: "dark",
  toastStyle: {
    background: "var(--bg-main-dark)",
    color: "var(--text-white)",
    border: "1px solid var(--border-dark)",
    borderRadius: "var(--border-radius-medium)",
    fontFamily: '"Inter", Source, system-ui, sans-serif',
    fontWeight: 200,
    fontSize: "var(--smallFontSize)",
  },
  closeOnClick: true,
});

// Mount the app
app.mount("#app");
